export const formatPhoneNumber = (phone: string | undefined) => {
  if (phone === undefined) return '';
  phone = phone.replace('+1', '');

  //check if number length equals to 10
  if (phone.length === 10) {
    //reformat and return phone number
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }

  return phone;
};
